<template>
  <div>
    <f-a-tabs class="mb-3" v-model="projectId" :items="[
        { label: '내부종사자 분야', value: 2},
        { label: '중대산업재해(도급·용역·위탁 사업) 분야', value: 3},
        { label: '발주사업 분야', value: 4},
        { label: '중대시민재해 분야', value: 5}
      ]" @input="() => {
        if (projectId === 5) {
          this.depth = 5
        } else {
          this.depth = 2
        }
        loadData();
      }"/>
    <div class="grid" style="grid-template-columns: 1fr 324px; height: 67vh;">
      <div class="relative">
        <!-- 네이버 지도 -->
        <div id="map" style="width:100%; height:100%;"></div>

        <!-- 현황 보기 -->
        <div v-if="isShowFieldDetail" class="py-6 absolute top-0 right-0 bottom-0"
             style="width: 360px; background: #fff; border: 1px solid #cdcdcd; z-index: 101; display: grid; grid-template-rows: auto auto 1fr;">
          <div class="px-6">
            <h3 class="mb-4 px-2 flex items-center border-bottom" style="font-size: 1.25rem; height: 64px;">
              <span class="flex-1">현황 보기</span>
              <span class="ml-auto flex items-center cursor-pointer" @click="hideFieldDetail" >
                <feather-icon icon="XIcon"/>
                <span style="font-size:14px; font-weight: 500; color:#696D71;">닫기</span>
              </span>
            </h3>
          </div>

          <div class="px-6 mb-6 flex flex-wrap items-center gap-3">
            <span style="font-size: 20px; font-weight: 500">{{ fieldInfo.field_name }}</span>
            <vs-select class="ml-auto" style="width: 110px;" autocomplete v-model="fieldSearchYear" @input="searchFieldData">
              <vs-select-item v-for="year in yearList" :key="`year_${year}`" :text="`${year}년`" :value="year" />
            </vs-select>
          </div>

          <div class="px-6 overflow-y-auto">
            <div class="data-group1">
              <div v-for="(stdInfo, index) in fieldStdInfo" :key="`fieldStdInfo_${index}`" class="data-item">
                <span class="data-item-label">{{ stdInfo.label }}</span>
                <span class="data-item-value">{{ stdInfo.value }}</span>
              </div>
            </div>

            <div v-if="fieldBoards.length > 0" class="data-group2">
              <div v-for="(board, index) in fieldBoards" :key="`fieldBoards_${index}`" class="data-item">
                <span class="data-item-label">{{ board.label }}</span>
                <span class="data-item-value text-right">{{ board.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 사업장 현황 -->
      <div class="py-6 h-full grid overflow-hidden" style="background: #fff; border: 1px solid #cdcdcd; grid-template-rows: auto auto 1fr auto">
        <div class="px-6">
          <h3 class="mb-4 px-2 flex items-center border-bottom" style="font-size: 1.25rem; height: 64px;">
            {{ projectId === 5 ? '시설물 현황' : '사업장 현황' }}</h3>
        </div>
        <div>
          <div v-if="projectId === 5" class="px-6 mb-6 flex justify-between">
            <vs-button class="py-2 px-9" type="border" @click="depth = 5">공중이용시설</vs-button>
            <vs-button class="py-2 px-9" type="border" @click="depth = 6">원료·제조물</vs-button>
          </div>
          <div v-else class="px-6 mb-6 flex justify-between">
            <vs-button class="py-2 px-10" type="border" @click="depth = 2">국</vs-button>
            <vs-button class="py-2 px-10" type="border" @click="depth = 3">과</vs-button>
            <vs-button class="py-2 px-10" type="border" @click="depth = 4">팀</vs-button>
          </div>
        </div>

        <!-- projectId 5 -->
        <div v-if="projectId === 5" class="scroll-container px-6 grid gap-2 overflow-y-auto relative" style="grid-auto-rows: min-content">
          <div v-for="(fieldGroup, i) in fieldGroupList" :key="`data_${i}`">
            <p class="data-item-company py-2 flex items-center gap-2 cursor-pointer" @click="toggleFoldFieldGroup(fieldGroup)">
              <span>{{ fieldGroup.name }}</span>
              <span class="ml-auto">{{ fieldGroup.fields.length }} 개소</span>
              <feather-icon icon="ChevronDownIcon" style="transition: all; transition-duration: 0.3s;"
                            :style="{ transform: openFieldGroup && (openFieldGroup.name === fieldGroup.name) ? 'rotate(180deg)' : '',
                                      color: fieldGroup.fields.length > 0 ? '#7E72F2' : '#cdcdcd'}"/>
            </p>
            <div
              v-if="fieldGroup.fields.length > 0 && openFieldGroup && (openFieldGroup.name === fieldGroup.name)"
              :id="`fieldGroup-fields-${openFieldGroup.code}`"
              class="px-4 grid gap-2"
              style="background-color: #E5E8EB">
              <p v-for="(field, fi) in fieldGroup.fields" :key="`data_${fieldGroup.com_name}_${field.field_name}_${fi}`" class="data-item-field flex items-center">
                <span class="px-2">{{ field.field_name }}</span>
                <a class="ml-auto p-2 cursor-pointer" style="min-width: 72px;" @click="showFieldDetail(field.id)">현황 보기</a>
              </p>
            </div>
          </div>
        </div>

        <!-- projectId 1 ~ 4 -->
        <div v-else class="scroll-container px-6 grid gap-2 overflow-y-auto relative" style="grid-auto-rows: min-content">
          <div v-for="(company, i) in companyList" :key="`data_${i}`">
            <p class="data-item-company py-2 flex items-center gap-2 cursor-pointer" @click="toggleFoldCompany(company)">
              <span>{{ company.com_name }}</span>
              <span class="ml-auto">{{ company.fields.length }} 개소</span>
              <feather-icon icon="ChevronDownIcon" style="transition: all; transition-duration: 0.3s;"
                            :style="{ transform: openCompany && (openCompany.id === company.id) ? 'rotate(180deg)' : '',
                                      color: company.fields.length > 0 ? '#7E72F2' : '#cdcdcd'}"/>
            </p>
            <div
              v-if="company.fields.length > 0 && openCompany && (openCompany.id === company.id)"
              :id="`company-fields-${company.id}`"
              class="px-4 grid gap-2"
              style="background-color: #E5E8EB">
              <p v-for="(field, fi) in company.fields" :key="`data_${company.com_name}_${field.field_name}_${fi}`" class="data-item-field flex items-center">
                <span class="px-2">{{ field.field_name }}</span>
                <a class="ml-auto p-2 cursor-pointer" style="min-width: 72px;" @click="showFieldDetail(field.id)">현황 보기</a>
              </p>
            </div>
          </div>
        </div>

        <div class="border-top pt-3 px-6">
          <p class="flex items-center gap-2" style="font-size: 16px; font-weight: 500">
            <span>{{ totalLabel }}</span>
            <span class="ml-auto">{{ this.totalFieldCount }} 개소</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FATabs from "@/components/FATabs.vue";
import * as DataUtil from "@/util/DataUtil";
import * as UiUtil from "@/util/UiUtil";

export default {
  name: 'ProjectMap',
  components: { FATabs },
  props: {

  },
  computed: {
    yearList () {
      const list = []
      for (let i=0; i<3; i++) {
        const year = new Date().getFullYear() - i
        list.push(year)
      }
      return list
    },
    totalLabel () {
      if (parseInt(this.projectId) === 2) {
        return '내부종사자 사업장수'
      }
      if (parseInt(this.projectId) === 3) {
        return '중대산업재해 사업장수'
      }
      if (parseInt(this.projectId) === 4) {
        return '발주사업 사업장수'
      }
      if (parseInt(this.projectId) === 5) {
        return '중대시민재해 사업장수'
      }
      return '사업장수'
    },
    companyList() {
      return this.companyListAll.filter(item => {
        const projectList = item.project.filter(project => {
          return parseInt(project.pivot.project_id) === parseInt(this.projectId) && parseInt(project.pivot.depth) === parseInt(this.depth)
        })
        return projectList.length > 0 ;
      });
    },
    fieldGroupList () {
      return this.fieldListAll.filter(field => {
        return field.depth === this.depth;
      });
    },
    fieldStdInfo() {
      if (this.fieldInfo && this.fieldInfo.stdInfo) {
        const keys = Object.keys(this.fieldInfo.stdInfo);
        return keys.map(key => {
          return {
            label: key,
            value: this.fieldInfo.stdInfo[key] || '정보 없음'
          };
        });
      }
      return [];
    },
    fieldBoards() {
      if (this.fieldInfo && this.fieldInfo.boards.length > 0) {
        return this.fieldInfo.boards
      }
      return [];
    },
  },
  data() {
    return {
      mapOptions: undefined,
      map: undefined,
      markers: [],
      isShowFieldDetail: false,
      fieldInfo: {
        field_id: 0,
        field_name: '',
        stdInfo: {},
        boards: [], // { board_id, label, value }
      },
      fieldSearchYear: new Date().getFullYear(),
      companyListAll: [], // 해당 분야의 모든 회사 목록
      openedInfoWindow: undefined, // 지도에 활성화 되어 있는 정보창
      totalFieldCount: 0, // 전체 필드 개수

      projectId: 2,
      depth: 2,
      openCompany: null, // 현재 열려있는 필드
      openFieldGroup: null, // 현재 열려있는 필드 그룹

      fields: [], // api 로부터 받아온 사업장 목록
      fieldListAll: [
        { name: '도서관', code: 'library', depth: 5, fields: [] },
        { name: '박물관 및 미술관', code: 'museum', depth: 5, fields: [] },
        { name: '의료기관', code: 'medical', depth: 5, fields: [] },
        { name: '어린이집', code: 'daycare', depth: 5, fields: [] },
        { name: '업무시설', code: 'office', depth: 5, fields: [] },
        { name: '실내공연장', code: 'indoor-auditorium', depth: 5, fields: [] },
        { name: '둘이상용도건축물', code: 'mixed-use-building', depth: 5, fields: [] },
        { name: '건축물', code: 'building', depth: 5, fields: [] },
        { name: '항만(방파제)', code: 'port', depth: 5, fields: [] },
        { name: '항만(부두)', code: 'port-dock', depth: 5, fields: [] },
        { name: '교량', code: 'bridge', depth: 5, fields: [] },
        { name: '터널', code: 'tunnel', depth: 5, fields: [] },
        { name: '옹벽', code: 'retaining-wall', depth: 5, fields: [] },
        { name: '절토사면', code: 'cutting-slope', depth: 5, fields: [] },
        { name: '제방', code: 'dike', depth: 5, fields: [] },
        { name: '하수처리시설', code: 'sewage-treatment', depth: 5, fields: [] },

        { name: '집단급식소', code: 'mass_feeding_facility', depth: 6, fields:[] },
      ],
    };
  },
  methods: {
    findField(field_id) {
      const filter =  this.fields.filter(field => {
        if (field.id === field_id) {
          return true;
        }
      })
      if (filter.length > 0) {
        return filter[0];
      }
      return null;
    },
    async showFieldDetail (field_id) {
      UiUtil.loading(true);

      try {
        const field = await this.$store.dispatch("project/LOAD_FIELD", { fieldId: field_id });
        this.fieldInfo.field_id = field_id;
        this.fieldInfo.field_name = field.field_name;
        if (parseInt(this.projectId) === 2) {
          this.fieldInfo.stdInfo = this.__getContentStdInfoProject2(field)
        } else if (parseInt(this.projectId) === 3) {
          this.fieldInfo.stdInfo = this.__getContentStdInfoProject3(field)
        } else if (parseInt(this.projectId) === 4) {
          this.fieldInfo.stdInfo = this.__getContentStdInfoProject4(field)
        } else if (parseInt(this.projectId) === 5) {
          this.fieldInfo.stdInfo = this.__getContentStdInfoProject5(field)
        }

        await this.searchFieldData();
      } catch (err) {}
      UiUtil.loading(false);
      this.isShowFieldDetail = true;
    },
    hideFieldDetail () {
      this.isShowFieldDetail = false;
      this.fieldInfo = {
        field_id: 0,
        field_name: '',
        stdInfo: {},
        boards: [],
      };
    },
    toggleFoldCompany(company) {
      const openCompanyId = this.openCompany ? this.openCompany.id : null;
      const willOpen = company.id !== openCompanyId;
      this.openCompany = willOpen ? company : null;
      this.openFieldGroup = null;

      this.filterMarkers();

      // 다음 tick에서 DOM이 렌더링된 후 스크롤 이동
      if (willOpen) {
        this.$nextTick(() => {
          const target = document.getElementById(`company-fields-${company.id}`);
          const container = document.querySelector('.scroll-container');
          const offset = 40; // 위로 살짝 올릴 픽셀 값

          if (target && container) {
            // 먼저 요소로 스크롤 (기본 정렬: 상단)
            target.scrollIntoView({ block: 'start', behavior: 'auto' });

            // 약간 위로 올리기 위해 scrollTop 조정
            container.scrollTop = container.scrollTop - offset;
          }
        });
      }
    },
    toggleFoldFieldGroup (fieldGroup) {
      const openFieldGroupCode = this.openFieldGroup ? this.openFieldGroup.code : null;
      const willOpen = fieldGroup.code !== openFieldGroupCode;
      this.openFieldGroup = willOpen ? fieldGroup : null;
      this.openCompany = null;

      this.filterMarkers();

      // 다음 tick 에서 DOM 이 렌더링된 후 스크롤 이동
      if (willOpen) {
        this.$nextTick(() => {
          const target = document.getElementById(`fieldGroup-fields-${fieldGroup.code}`);
          const container = document.querySelector('.scroll-container');
          const offset = 40; // 위로 살짝 올릴 픽셀 값

          if (target && container) {
            // 먼저 요소로 스크롤 (기본 정렬: 상단)
            target.scrollIntoView({ block: 'start', behavior: 'auto' });

            // 약간 위로 올리기 위해 scrollTop 조정
            container.scrollTop = container.scrollTop - offset;
          }
        });
      }
    },

    async loadFieldListAll() {
      const fieldParams = {
        projectId: this.projectId,
        page: 1,
        perPage: 50,
        showAll: true, // 참여여부와 상관없이 모든 사업장 조회
        withAddress: true, // field_address (다음지도에서 제공해주는 주소정보)
      };
      const fields = await DataUtil.loadDefragmentation(this.$store, "project/LOAD_FIELD_LIST", fieldParams);
      this.fields = JSON.parse(JSON.stringify(fields));
      this.totalFieldCount = fields.length;

      // field_address 를 사용하여 지도에 마커 추가
      const _fieldCodeGroup = {};
      fields.forEach(field => {
        if (!_fieldCodeGroup[`${field.field_code}`.trim()]) _fieldCodeGroup[`${field.field_code}`.trim()] = [];
        _fieldCodeGroup[`${field.field_code}`.trim()].push(field)

        if (field.field_address && field.field_address.y && field.field_address.x) {
          this.addMarker(field.id, field.field_address.y, field.field_address.x, field.field_name, this.getContentForInfoWindow(this.projectId, field));
        }
      });

      this.fieldListAll.forEach(fieldGroup => {
        fieldGroup.fields = _fieldCodeGroup[fieldGroup.code] || [];
      });
    },
    getContentForInfoWindow (projectId, field) {
      if (parseInt(projectId) === 2) {
        const content = this.__getContentStdInfoProject2(field);
        // 리스트처럼 표기하고 싶을 경우,
        // 출력예시 " - 예산 편성액: 10,000,000원"
        // content['list']= {};
        // content['list']['예산 편성액'] = '10,000,000원';
        // content['list']['예산 집행액'] = '1,000,000원';
        // content['list']['유해위험요인파악'] = '30건';
        // content['list']['위험성평가'] = '20건';
        // content['list']['개선조치현황'] = '10건';
        // content['list']['3등급판단법'] = '10건';
        // content['list']['주간점검회의'] = '10건';
        // content['list']['일일 TBM'] = '10건';
        // content['list']['안전보건 점검 현황'] = '10건';
        // content['list']['안전보건 교육 현황'] = '10건';
        // content['list']['사고발생 현황'] = '10건';
        return content
      } else if (parseInt(projectId) === 3) {
        return this.__getContentStdInfoProject3(field);
      } else if (parseInt(projectId) === 4) {
        return this.__getContentStdInfoProject4(field);
      } else if (parseInt(projectId) === 5) {
        return this.__getContentStdInfoProject5(field);
      }
      return {};
    },
    __getContentStdInfoProject2(field) {
      const meta = field.meta ? JSON.parse(field.meta): {};
      return {
        '부서명': meta.field_name || '정보 없음',
        '담당주무관': field.manager_name || '정보 없음',
        '사업장 주소': field.address || '정보 없음',
        '사업기간': field.work_begin_at || field.work_end_at ? `${field.work_begin_at} ~ ${field.work_end_at}` : '정보 없음',
      };
    },
    __getContentStdInfoProject3(field) {
      const meta = field.meta ? JSON.parse(field.meta): {};
      return {
        '부서명': meta.field_name || '정보 없음',
        '담당주무관': field.manager_name || '정보 없음',
        '사업장 주소': field.address || '정보 없음',
        '사업기간': field.work_begin_at || field.work_end_at ? `${field.work_begin_at} ~ ${field.work_end_at}` : '정보 없음',
        // '사업금액(원)': field.deposit_amount || '정보 없음',
        // '사업장 연락처': field.phone || '정보 없음',
        '수급업체명': meta.수급업체명 || '정보 없음',
        '수급업체 담당자': meta.수급업체담당자 || '정보 없음',
        '수급업체 연락처': meta.수급업체연락처 || '정보 없음',
      };
    },
    __getContentStdInfoProject4(field) {
      const meta = field.meta ? JSON.parse(field.meta): {};
      return {
        '부서명': meta.field_name || '정보 없음',
        '담당주무관': field.manager_name || '정보 없음',
        '사업장 주소': field.address || '정보 없음',
        '사업기간': field.work_begin_at || field.work_end_at ? `${field.work_begin_at} ~ ${field.work_end_at}` : '정보 없음',
        '구분': '교량',
        '종류': '도로교량',
        '수급업체명': meta.수급업체명 || '정보 없음',
        '현장소장': meta.director_name || '정보 없음',
        '현장소장 연락처': meta.현장소장연락처 || '정보 없음',
      };
    },
    __getContentStdInfoProject5(field) {
      const meta = field.meta ? JSON.parse(field.meta): {};
      return {
        '관리방법': meta.관리방법 || '정보 없음',
        '소관부서': meta.소관부서 || '정보 없음',
        '담당주무관': meta.담당주무관 || '정보 없음',
        '주소': field.address || '정보 없음',
      };
    },

    async loadCompanyListAll() {
      const company = await DataUtil.loadDefragmentation(this.$store, "company/LOAD_COMPANY_LIST", {
        page:1,
        perPage: 100,
        projectId: this.projectId,
      }, true)
      let companyListAll = company.map(item => {
        item.fields = item.fields.filter((field) => {
          const findField = this.findField(field.id);
          return !!findField
        })

        return {
          ...item,
          project: item.project.map(project => {
            return {
              ...project,
              pivot: {
                ...project.pivot,
                depth: parseInt(project.pivot.company_path.split('/').length - 1)
              }
            }
          })
        }
      });

      // 사업장 이름순으로 정렬
      companyListAll = companyListAll.map(company => {
        return {
          ...company,
          fields: [...company.fields].sort((a, b) => {
            return a.field_name.localeCompare(b.field_name);
          })
        };
      });

      // 정렬
      this.companyListAll = companyListAll.sort((a, b) => {
        // 이름순으로 정렬
        return a.com_name.localeCompare(b.com_name);
      });
    },
    async loadData() {
      UiUtil.loading(true)
      this.cleanMarkers();
      await this.loadFieldListAll();
      await this.loadCompanyListAll();
      UiUtil.loading(false)
    },
    initMap() {
      // Code to run when the component is mounted
      this.mapOptions = {
        center: new naver.maps.LatLng(36.586148, 128.1867972),
        zoom: 12
      };
      this.map = new naver.maps.Map('map', this.mapOptions);


      window.maot = {
        fieldDetail: (field_id) => {
          this.showFieldDetail(field_id);
        }
      }
    },
    filterMarkers() {
      if (this.openedInfoWindow) this.openedInfoWindow.close();
      this.markers.forEach(marker => {
        if (this.openCompany) {
          const fieldIds = this.openCompany.fields.map(field => field.id);
          if (fieldIds.includes(marker.field_id)) {
            marker.setMap(this.map);
          } else {
            marker.setMap(null);
          }
        } else if (this.openFieldGroup) {
          const fieldIds = this.openFieldGroup.fields.map(field => field.id);
          if (fieldIds.includes(marker.field_id)) {
            marker.setMap(this.map);
          } else {
            marker.setMap(null);
          }
        } else {
          marker.setMap(this.map);
        }
      });
    },
    cleanMarkers() {
      if (this.openedInfoWindow) this.openedInfoWindow.close();
      this.markers.forEach(marker => {
        marker.setMap(null);
      });
      this.markers = [];
    },

    addMarker(field_id, lat, lng, title, content) {
      //content = { 부서명: '○○○○과', 담당주무관: '홍길동'}
      const marker = new naver.maps.Marker({
        map: this.map,
        position: new naver.maps.LatLng(lat, lng) //37.5666805, 126.9784147
      });
      const infowindow = new naver.maps.InfoWindow({
        content: this.__addMarker_content(field_id, title, content),
        borderWidth: 0,
        disableAnchor: true,
        backgroundColor: 'transparent',
        pixelOffset: new naver.maps.Point(0, 0)
      });
      naver.maps.Event.addListener(marker, "mouseover", () => {
        if (!infowindow.getMap()) {
          infowindow.open(this.map, marker);
          this.openedInfoWindow = infowindow;
        } else {
          infowindow.close();
          this.openedInfoWindow = undefined;
        }
      });
      marker.field_id = field_id;
      marker.raw = content;
      this.markers.push(marker)
    },
    __addMarker_content(field_id, title, content) {
      const result = [
        '<div class="iw_inner">',
        ' <div class="iw_inner_body">',
        `   <h3 class="iw_inner_title">${title}</h3>`,
      ];

      const contentKeys = Object.keys(content);
      const contentHtml = contentKeys.map(key => {
        if (key === 'list') {
          const listContent = content[key];
          return Object.keys(listContent).map((subKey, index) => {
            return `<p class="iw_inner_p_sub ${index === 0 && 'first' || ''}">${subKey} : ${listContent[subKey]}</p>`;
          }).join('');
        } else {
          return `<p class="iw_inner_p">${key} : ${content[key]}</p>`;
        }
      }).join('');
      result.push(contentHtml);

      result.push(...[
        `   <div class="iw_inner_btn" onClick="window.maot.fieldDetail(${field_id})">현황 보기</div>`,
        ' </div>',
        ' <div class="iw_inner_arrow">',
        ' </div>',
        '</div>'
      ])
      return result.join('')
    },
    async searchFieldData () {
      UiUtil.loading(true)
      const boards = [];
      if (this.fieldInfo.field_name) {
        if (parseInt(this.projectId) === 2) {
          boards.push(...await this.__setBoardsCountProject2())
        } else if (parseInt(this.projectId) === 3) {
          boards.push(...await this.__setBoardsCountProject3())
        } else if (parseInt(this.projectId) === 4) {
          boards.push(...await this.__setBoardsCountProject4())
        } else if (parseInt(this.projectId) === 5) {
          boards.push(...await this.__setBoardsCountProject5())
        }
      }
      this.fieldInfo.boards = boards;
      UiUtil.loading(false)
    },

    async __setBoardsCountProject2() {
      const boards = [];
      await this.__setData_board106(boards);
      await this.__setCount_board(2, boards, [108, 157, 158, 159, 305], '유해위험요인파악')
      await this.__setCount_board(2, boards, [450, 162], '위험성평가')
      await this.__setCount_board(2, boards, [160], '개선조치현황', 'created_at', [{key: 'body.inputE_5', operator: '=', value: '조치 완료'}])
      await this.__setCount_board(2, boards, [137, 291, 290, 886, 100, 289, 292, 293, 296, 219, 221, 216, 217, 218, 220, 112, 180, 210, 196, 213, 200, 188, 196, 203, 212, 176, 166, 226, 224, 110, 189, 230, 229, 205, 171, 172, 182, 199, 184, 227, 174, 173, 113, 225, 206, 168, 169, 170, 223, 179, 194, 201, 233, 211, 193, 164, 208, 202, 190, 197, 192, 178, 177, 207, 231, 165, 175, 191, 214, 181, 204, 187, 186, 185, 228, 167, 183, 222, 195, 438], '안전보건 점검 현황')
      await this.__setCount_board(2, boards, [434], '안전보건 교육 현황')
      await this.__setCount_board(2, boards, [117], '사고발생 현황')
      return boards;
    },

    async __setBoardsCountProject3() {
      const boards = [];
      await this.__setData_board106(boards);
      await this.__setCount_board(2, boards, [108, 157, 158, 159, 305], '유해위험요인파악')
      await this.__setCount_board(2, boards, [450, 162], '위험성평가')
      await this.__setCount_board(2, boards, [160], '개선조치현황', 'created_at', [{key: 'body.inputE_5', operator: '=', value: '조치 완료'}])
      await this.__setCount_board(2, boards, [137, 291, 290, 886, 100, 289, 292, 293, 296, 219, 221, 216, 217, 218, 220, 112, 180, 210, 196, 213, 200, 188, 196, 203, 212, 176, 166, 226, 224, 110, 189, 230, 229, 205, 171, 172, 182, 199, 184, 227, 174, 173, 113, 225, 206, 168, 169, 170, 223, 179, 194, 201, 233, 211, 193, 164, 208, 202, 190, 197, 192, 178, 177, 207, 231, 165, 175, 191, 214, 181, 204, 187, 186, 185, 228, 167, 183, 222, 195, 438], '안전보건 점검 현황')
      await this.__setCount_board(2, boards, [434], '안전보건 교육 현황')
      await this.__setCount_board(2, boards, [117], '사고발생 현황')
      return boards;
    },

    async __setBoardsCountProject4() {
      const boards = [];
      await this.__setData_board106(boards);
      await this.__setCount_board(2, boards, [108, 157, 158, 159, 305], '유해위험요인파악')
      await this.__setCount_board(2, boards, [450, 162], '위험성평가')
      await this.__setCount_board(2, boards, [160], '개선조치현황', 'created_at', [{key: 'body.inputE_5', operator: '=', value: '조치 완료'}])
      await this.__setCount_board(2, boards, [137, 291, 290, 886, 100, 289, 292, 293, 296, 219, 221, 216, 217, 218, 220, 112, 180, 210, 196, 213, 200, 188, 196, 203, 212, 176, 166, 226, 224, 110, 189, 230, 229, 205, 171, 172, 182, 199, 184, 227, 174, 173, 113, 225, 206, 168, 169, 170, 223, 179, 194, 201, 233, 211, 193, 164, 208, 202, 190, 197, 192, 178, 177, 207, 231, 165, 175, 191, 214, 181, 204, 187, 186, 185, 228, 167, 183, 222, 195, 438], '안전보건 점검 현황')
      await this.__setCount_board(2, boards, [434], '안전보건 교육 현황')
      await this.__setCount_board(2, boards, [117], '사고발생 현황')
      return boards;
    },

    async __setBoardsCountProject5() {
      //const menu = ['예산편성액', '예산집행액', '안전인력 운용현황', '안전점검 및 보수보강 등 유지관리 현황', '주요 유해위험 요인 발생 및 조치현황', '안전보건 점검 현황', '안전보건 교육이수 현황', '사고발생 현황'];
      const boards = [];
      try {
        await this.__setData_board1044(boards);
      } catch(e) {}
      await this.__setCount_board(5, boards, [], '안전인력 운용현황')
      await this.__setCount_board(5, boards, [], '안전점검 및 보수보강 등 유지관리 현황')
      await this.__setCount_board(5, boards, [], '주요 유해위험 요인 발생 및 조치현황')
      await this.__setCount_board(5, boards, [], '안전보건 점검 현황')
      await this.__setCount_board(5, boards, [], '안전보건 교육 현황')
      await this.__setCount_board(5, boards, [], '사고발생 현황')

      // menu 순서대로 정렬
      // return boards.sort((a, b) => {
      //   return menu.indexOf(a.label) - menu.indexOf(b.label);
      // });
      return boards;
    },


    async __setData_board106(boards) {
      const list = await DataUtil.loadDefragmentation(this.$store, "board/LOAD_POST_LIST", {
        boardId: 106,
        page: 1,
        perPage: 100,
        conditions: [
          { key: 'created_at', operator: '>=', value: `${this.fieldSearchYear}-01-01`},
          { key: 'created_at', operator: '<', value: `${this.fieldSearchYear+1}-01-01`},
          { key: 'body.stdInfo.field_name', operator: '=', value: this.fieldInfo.field_name}
        ],
        withMeta: true,
        metaKeys: [
          'body.total.value1',
          'body.total.value2',
          'body.total.value3',
        ],
      });
      let 편성액 = 0, 집행액 = 0;
      if (list.length > 0) {
        편성액 = list[0].postContents.body.total.value1
        // 집행액 = 모든 게시물의 body.total.value2 합계
        집행액 = list.reduce((sum, post) => {
          return sum + parseInt((post.postContents.body.total.value2 || 0));
        }, 0);
      }

      boards.push({ label: '예산편성액', value: `${DataUtil.comma(편성액)} 원` });
      boards.push({ label: '예산집행액', value: `${DataUtil.comma(집행액)} 원` });
      return {

      }
    },
    async __setData_board1044(boards) {
      const list = await DataUtil.loadDefragmentation(this.$store, "board/LOAD_POST_LIST", {
        boardId: 1044,
        page: 1,
        perPage: 100,
        conditions: [
          { key: 'body.year', operator: '=', value: this.fieldSearchYear},
          { key: 'body.fields[%].field_name', operator: '=', value: this.fieldInfo.field_name}
        ],
      });

      let 편성액 = 0;
      let 집행액 = 0;
      let 확보인원 = 0;
      let 유지관리 = 0;
      let 조치현황 = 0;
      let 교육이수 = 0;
      let 사고발생 = 0;
      if (list.length > 0) {
        for (const post of list) {
          const content = JSON.parse(post.post_content);
          const body = content.body;
          if (body.합계) {
            편성액 += parseInt(body.합계.편성액 || 0);
            집행액 += parseInt(body.합계.집행액 || 0);
          }
          if (body.type1Checked.includes('안전인력 운용현황') && body.안전인력_운용현황 && body.안전인력_운용현황.length > 0) {
            body.안전인력_운용현황.forEach(item => {
              if (item.cell1) {
                확보인원 += parseInt(item.cell1 || 0);
              }
            });
          }
          if (body.type1Checked.includes('안전점검 및 보수보강 등 유지관리 현황') && body.유지관리_현황_정기점검 && body.유지관리_현황_수시점검.length > 0) {
            // 정기점검과 수시점검의 길이를 합산 (단, 내용이 존재할 때만)
            유지관리 += body.유지관리_현황_정기점검.filter(item => item.cell1 || item.cell2 || item.cell3 || item.cell4 || item.cell5).length;
            유지관리 += body.유지관리_현황_수시점검.filter(item => item.cell1 || item.cell2 || item.cell3 || item.cell4).length;
          }
          if (body.type1Checked.includes('주요 유해위험 요인 발생 및 조치현황') && body.주요유해위험요인발생및조치현황 && body.주요유해위험요인발생및조치현황.length > 0) {
            조치현황 += body.주요유해위험요인발생및조치현황.filter(item => item.cell1 || item.cell2 || item.cell3 || item.cell4).length;
          }
          if (body.type1Checked.includes('교육 이수현황') && body.교육이수현황 && body.교육이수현황.length > 0) {
            교육이수 += body.교육이수현황.filter(item => item.take === '이수').length;
          }
          if (body.type2Checked.includes('사고발생 현황') && body.사고발생현황 && body.사고발생현황.length > 0) {
            for (const data of body.사고발생현황) {
              if (data.cell1 === '계') {
                사고발생 += data.cell2
              }
            }
          }
        }
      }
      boards.push({ label: '예산편성액', value: `${DataUtil.comma(편성액)} 원` });
      boards.push({ label: '예산집행액', value: `${DataUtil.comma(집행액)} 원` });
      boards.push({ label: '안전인력 운용현황', value: `${DataUtil.comma(확보인원)} 명` });
      boards.push({ label: '안전점검 및 보수보강 등 유지관리 현황', value: `${DataUtil.comma(유지관리)} 건` });
      boards.push({ label: '주요 유해위험 요인 발생 및 조치현황', value: `${DataUtil.comma(조치현황)} 건` });
      boards.push({ label: '안전보건 교육이수 현황', value: `${DataUtil.comma(조치현황)} 명` });
      boards.push({ label: '사고발생 현황', value: `${DataUtil.comma(사고발생)} 명` });
    },
    async __setCount_board(projectId, boards, boardIds, label, dateKey = 'created_at', conditions = []) {
      try {
        const data = await this.$store.dispatch("board/LOAD_SUMMARY_POST_COUNT", {
          projectId,
          boardIds,
          fieldIds: [this.fieldInfo.field_id],
          dateFrom: `${this.fieldSearchYear}-01-01`,
          dateTo: new Date(`${this.fieldSearchYear}-12-31`).format('yyyy-MM-dd'),
        });
        boards.push({ label, value: `${data.total_count} 건` });
      }catch (err) {
        boards.push({ label, value: `0 건` });
      }
    },
  },
  async mounted() {
    this.initMap();
    await this.loadData();
  }
}

</script>

<style scoped lang="scss">
.data-item {
  .data-item-label,
  .data-item-value {
    display: block;
    padding: 14px;
    border-bottom: 1px solid #cdcdcd;
  }
}
.data-item-label {
  background: #FAFAFA;
}
.data-item-company {
  background-color: #fff;
  font-size: 16px;
  position:sticky;
  z-index: 1;
  top:0;

  &:hover {
    background-color: #f9f9f9;
  }
}
.data-item-field {
  span {
    display: block;
    padding-left: 1em; // 들여쓰기 효과
    position: relative;

    &::before {
      content: '-';
      position: absolute;
      left: 0;
    }
  }
  &:hover {
    background-color: #efefef;
  }
}
.data-group1 {
  border-top: 1px solid #cdcdcd;
  .data-item {
    display: grid;
    grid-template-columns: 100px 1fr;
  }
}
.data-group2 {
  margin-top: 20px;
  border-top: 1px solid #cdcdcd;
  .data-item {
    display: grid;
    grid-template-columns: 164px 1fr;
  }
}
</style>

<style lang="scss">
.iw_inner_body {
  padding: 0.8rem;
  border-radius: 8px;
  background-color: #3E3E3E;

  color: #FFFFFF;
}
.iw_inner_arrow {
  margin-left: auto;
  margin-right: auto;
  margin-top: -2px;
  width: 24px;
  height: 16px;
  background: #3E3E3E;
  clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
}
.iw_inner_title {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  padding-bottom: 10px !important;
}

.iw_inner_p {
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 4px;
}
.iw_inner_p_sub {
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 4px;

  display: block;
  padding-left: calc(1em + 8px); // 들여쓰기 효과
  position: relative;

  &.first {
    margin-top: 1rem !important;
  }
  &::before {
    content: '·';
    position: absolute;
    left: 0;
    padding-left: 8px;
  }
}
.iw_inner_btn {
  margin-top: 10px;
  padding: 4px;
  border: 1px solid #CDCDCD;
  border-radius: 4px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
</style>
